export const isNotificationAvailable = () => {
  return (
    typeof window !== 'undefined' &&
    typeof window.Notification !== 'undefined' &&
    typeof window.Notification.permission === 'string'
  );
};

export const getNotificationPermission = () => {
  if (!isNotificationAvailable()) return 'unsupported';
  return window.Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (!isNotificationAvailable()) return 'unsupported';

  if (window.Notification.permission === 'granted') {
    return 'granted';
  }

  return window.Notification.requestPermission();
};
